<template>
  <div class="device-manage">
    <div class="device-manage-content">
      <filter-bar
        :itemArray="itemArray"
        :initialSelectedIndex="selectedComponentIndex"
        :buttonTitle="filterBarButtonTitle"
        keywordTitle="搜索设备SN"
        v-model="keyword"
        @onItemSelected="onItemSelected"
        @onButtonClick="onAddDeviceClick"
        @onSearchClick="onSearchClick"
      >
        <template #before-search>
          <el-button
            v-if="canImportRingUsers"
            class="ring-import-button"
            type="primary"
            size="small"
            @click="onImportRingClick"
          >批量导入</el-button>
        </template>
      </filter-bar>
      <component
        ref="component"
        :is="currentComponent"
        :canDeleteDevice="canDeleteDevice"
        @onAddUserClick="onAddUserClick"
        @onRecycleDeviceClick="onRecycleDeviceClick"
      >
      </component>
    </div>
    <ring-import-dialog
      v-if="isShowRingImportDialog"
      :hospital="importHospital"
      @close="isShowRingImportDialog = false"
      @success="onRingImportSuccess"
    />
  </div>
</template>

<script>
import FilterBar from "@c/operation-log/common/filter-bar/filter-bar.vue";
import Monitor from "@c/device-manage/monitor/monitor.vue";
import Ring from "@c/device-manage/ring/ring.vue";
import ChildRing from "@c/device-manage/child-ring/child-ring.vue";
import RingImportDialog from "@c/device-manage/child-ring/ring-import-dialog.vue";
import { CacheTool } from "@js/cache-tool.js";
export default {
  components: {
    FilterBar,
    Monitor,
    Ring,
    ChildRing,
    RingImportDialog,
  },

  data() {
    return {
      selectedComponentIndex: 0,
      keyword: "",
      itemArray: ["监护仪", "监护仪绑定指环", "儿童OSA绑定指环"],
      filterBarButtonTitle: undefined,
      canDeleteDevice: undefined,
      isShowRingImportDialog: false,
      importHospital: null,
    };
  },

  computed: {
    canImportRingUsers() {
      return this.selectedComponentIndex === 2 &&
        String(this.$store.state.selectedHospital.hospitalid) === "87";
    },
    currentComponent() {
      switch (this.selectedComponentIndex) {
        case 0:
          return "monitor";
        case 1:
          return "ring";
        case 2:
          return "childRing";
        default:
          return "";
      }
    },
  },

  async mounted() {
    await this.getLatestUserInfo();
    this.getFilterBarButtonTitle();
    this.canDeleteDevice = this.$store.state.accountInfo.deviceManagement;
  },

  watch: {
    selectedComponentIndex() {
      this.getFilterBarButtonTitle();
    },
  },

  methods: {
    onImportRingClick() {
      if (!this.canImportRingUsers) return;
      this.importHospital = { ...this.$store.state.selectedHospital };
      this.isShowRingImportDialog = true;
    },

    onRingImportSuccess(hospitalId) {
      if (this.selectedComponentIndex === 2 &&
          String(this.$store.state.selectedHospital.hospitalid) === String(hospitalId)) {
        this.$refs.component.getRingList();
      }
      // 用户管理未缓存，切换进入时 mounted 会重新请求患者列表。
    },
    onItemSelected(index) {
      this.selectedComponentIndex = index;
      this.keyword = undefined;
    },

    onSearchClick(keyword) {
      this.$nextTick(() => {
        this.$refs.component.onSearchClick(keyword);
      });
    },

    onAddUserClick(selectedModel) {
      this.$emit("onAddUserClick", selectedModel);
    },

    onAddDeviceClick() {
      this.$nextTick(() => {
        this.$refs.component.onAddDeviceClick();
      });
    },

    onRecycleDeviceClick(selectedModel) {
      this.$emit("onRecycleDeviceClick", selectedModel);
    },

    async getFilterBarButtonTitle() {
      if (this.selectedComponentIndex == 2) {
        this.filterBarButtonTitle = null;
      } else {
        this.filterBarButtonTitle = this.$store.state.accountInfo
          .deviceManagement
          ? "新增设备"
          : null;
      }
    },

    async getLatestUserInfo() {
      try {
        const loginInfo = CacheTool.getLoginInfo();
        const params = { id: loginInfo.uid };
        const response = await this.$api.userInfo(params);
        const currentAccountInfo = this.$store.state.accountInfo || {};
        const responseHasAnonymization = Object.prototype.hasOwnProperty.call(
          response,
          "anonymization"
        );
        const nextAccountInfo = {
          ...currentAccountInfo,
          ...response,
          anonymization: responseHasAnonymization
            ? response.anonymization
            : currentAccountInfo.anonymization,
        };
        if (
          nextAccountInfo.deviceManagement == currentAccountInfo.deviceManagement &&
          nextAccountInfo.anonymization === currentAccountInfo.anonymization
        ) {
          return;
        }
        this.$store.commit("saveAccountInfo", nextAccountInfo);
      } catch {}
    },
  },
};
</script>

<style lang="scss" scoped>
.device-manage {
  background-color: #eff2f7;

  &-content {
    background-color: white;
    box-sizing: border-box;
    padding: 0 20px;
    flex: 1;
  }
}
.ring-import-button {
  font-size: 14px;
}
</style>
